// extracted by mini-css-extract-plugin
module.exports = {"subsectionTitle":"GuardianDetailsFields_subsectionTitle__1uAuQ"};